// extracted by mini-css-extract-plugin
module.exports = {"simpleLabel":"toolbarselects_simpleLabel__gan-P","choiceBoxes":"toolbarselects_choiceBoxes__83cIp","simpleField":"toolbarselects_simpleField__2XnBT"};